import { Carousel as MantineCarousel } from "@mantine/carousel"
import { QuestionForecastCard } from "atlas_forecasting_app/components/forecast/question_forecast_card"

export function Carousel({ items }) {
  if (!items.length) return null

  return (
    <MantineCarousel
      withIndicators
      emblaOptions={{ align: "start", loop: false }}
      slideGap="md"
      slideSize="100%"
      breakpoints={[
        { minWidth: "48em", slideSize: "70%" },
        { minWidth: "75em", slideSize: "54%" },
      ]}
    >
      {items.map((item) => (
        <MantineCarousel.Slide key={item?.question?.id || item?.latest_forecast?.id}>
          <QuestionForecastCard item={item} variant="carousel" />
        </MantineCarousel.Slide>
      ))}
    </MantineCarousel>
  )
}
